module.exports = __webpack_public_path__ + "img/cancel-icon.f3fd4603.png";